import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function CtaSectionV2() {
  return (
    <section className="py-24">
      <div className="mx-auto max-w-5xl px-6">
        <div className="rounded-3xl border border-brand/20 bg-brand/4 px-6 py-16 text-center shadow-2xl shadow-brand/10 dark:bg-brand/5 dark:border-brand/20">
          <h2 className="font-display text-foreground text-4xl tracking-normal sm:text-5xl">
            Start building AI pipelines today
          </h2>

          <div className="mt-8 flex items-center justify-center gap-4">
            <Button
              className="bg-brand hover:bg-brand/90! cursor-pointer rounded-lg px-6 text-white"
              asChild
            >
              <Link to="/signup">Get started</Link>
            </Button>
            <Button
              variant="outline"
              className="cursor-pointer rounded-lg px-6"
              asChild
            >
              <Link to="/demo">Watch demo</Link>
            </Button>
          </div>

          {/* Info cards */}
          <div className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2">
            <div className="rounded-xl border border-black/5 bg-card p-5 shadow-sm dark:border-white/10 dark:bg-white/5">
              <h3 className="text-foreground text-sm font-semibold">
                Templates for every use case
              </h3>
              <p className="text-muted-foreground mt-1 text-sm leading-relaxed">
                Pre-built pipelines for YouTube Shorts, product videos, music
                videos, and more.
              </p>
            </div>
            <div className="rounded-xl border border-black/5 bg-card p-5 shadow-sm dark:border-white/10 dark:bg-white/5">
              <h3 className="text-foreground text-sm font-semibold">
                From idea to content in minutes
              </h3>
              <p className="text-muted-foreground mt-1 text-sm leading-relaxed">
                Describe your vision, let AI build the pipeline, and generate
                finished content with one click.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
